
<div class="val-bandeau-recherche">
  <div class="val-bandeau-recherche-commande val-flex-conteneur">
    <div class="val-flex-1"></div>
    <div class="val-bandeau-recherche-rafraichir"
         (click)="Rafraichir()">
      <val-fonte-icone iconeCss="fas fa-redo"></val-fonte-icone>
    </div>
    <div class="val-bandeau-recherche-fermer-ouvrir"
         (click)="OuvrirFermer()">
      <val-fonte-icone iconeCss="fas fa-chevron-up"
                       [utiliserRotation180]="true"
                       [rotation]="!ouvert"
      ></val-fonte-icone>
    </div>
  </div>
  <div class="val-bandeau-recherche-contenu"
       [style.height]="taille + 'px'"
       [class.ouvert]="ouvert"
       [class.ferme]="!ouvert">
    @for (ligne of lignes; track $index) 
    {
      <p class="val-bandeau-recherche-ligne"
         [innerHTML]="ligne | val_markdown">
      </p>
    }
  </div>
</div>
